"use client";

import { c as _c } from "react/compiler-runtime";
import { useTranslation } from "@/app/i18n/client";
import { createCompanyURI } from "@/components/Util/AdvertiserHelpers";
import PaginatedTable from "@/components/Util/Table/PaginatedTable";
import { LocaleName } from "@/app/i18n/settings";
import { AdvertiserLocationWithCompany } from "@/types/location";
import Image from "next/image";
import { useRouter } from "next/navigation";
import { useState } from "react";
import matchbusIcon from "@/assets/images/matchbus_icon.jpg";
export default function AdvertiserList(t0) {
  const $ = _c(21);
  const {
    advertisers,
    lng
  } = t0;
  const [currentPage, setCurrentPage] = useState(1);
  const router = useRouter();
  const {
    t
  } = useTranslation("advertiser");
  let t1;
  if ($[0] !== advertisers) {
    t1 = advertisers ?? [];
    $[0] = advertisers;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("TABLE.HEADERS.COMPANYNAME");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("TABLE.HEADERS.ADDRESS");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t("TABLE.HEADERS.EMAIL");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t3 || $[10] !== t4) {
    t5 = [t2, t3, t4];
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = ["text-center", "text-center", "text-center"];
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== lng || $[14] !== router) {
    t7 = advertiser => {
      const url = createCompanyURI(advertiser.company, lng);
      return <tr key={advertiser.advertiserLocation.id} onClick={() => router.push(url)}><td className="flex min-w-max flex-row flex-nowrap items-center gap-4"><Image alt="logo" width="80" height="80" src={advertiser.company.profileInfo?.logoPicture ?? matchbusIcon} className="h-12 w-12 object-contain px-2 xxl:h-16 xxl:w-16" /><div className="grow whitespace-nowrap font-bold">{advertiser.company.publicData.companyName}</div></td><td className="whitespace-nowrap text-center text-xxs lg:text-xs xxl:text-sm">{advertiser.advertiserLocation.address.address.split(",").map((line, i, arr) => <span className="lg:leading-none xxl:leading-[1.1]" key={"line" + i + advertiser.advertiserLocation.id}>{line}{i < arr.length - 1 && <br />}</span>)}</td><td className="text-center">{advertiser.advertiserLocation.contact.email}</td></tr>;
    };
    $[13] = lng;
    $[14] = router;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== currentPage || $[17] !== t1 || $[18] !== t5 || $[19] !== t7) {
    t8 = <PaginatedTable table="Tablev2" className="rounded-b-3xl bg-babyBlue py-4" tableClassName="popRow" items={t1} itemsPerPage={10} currentPage={currentPage} updateCurrentPage={setCurrentPage} alwaysShowPagination={true} headers={t5} headerClasses={t6} createTableRow={t7} />;
    $[16] = currentPage;
    $[17] = t1;
    $[18] = t5;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
}